import React from 'react';
import { Search } from 'lucide-react';
export interface SearchBarProps {
  placeholder?: string;
  value?: string;
  onChange?: (value: string) => void;
  className?: string;
  'data-id'?: string;
}
export function SearchBar({
  placeholder = 'Search...',
  value = '',
  onChange,
  className = '',
  'data-id': dataId
}: SearchBarProps) {
  return <div className={`relative ${className}`} data-id="element-2529">
      <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#94A3B8] pointer-events-none" data-id="element-2530" />
      <input type="text" placeholder={placeholder} value={value} onChange={e => onChange?.(e.target.value)} className="w-full h-10 pl-10 pr-4 bg-white border border-[#CBD5E1] rounded-md text-[14px] text-[#0F172A] placeholder:text-[#94A3B8] focus:outline-none focus:border-[#0EA5E9] focus:ring-2 focus:ring-[rgba(14,165,233,0.2)] transition-all duration-200" data-id="element-2531" />
    </div>;
}